import { StorageHandler, StorageOptions } from "../../types/storage";

/* global Office, console */

export class OfficeStorageHandler implements StorageHandler {
  async get(key: string): Promise<string | null> {
    try {
      if (!Office.context.roamingSettings) {
        console.error("Office storage not available");
        return null;
      }

      return (Office.context.roamingSettings.get(key) as string) || null;
    } catch (error) {
      console.error("Error reading from Office storage:", error);
      return null;
    }
  }

  async set(
    key: string,
    value: string,
    options?: StorageOptions,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (!Office.context.roamingSettings) {
          return reject("Office storage not available");
        }

        Office.context.roamingSettings.set(key, value);

        if (options) {
          for (const [optionKey, optionValue] of Object.entries(options)) {
            Office.context.roamingSettings.set(
              `${key}_${optionKey}`,
              optionValue,
            );
          }
        }

        Office.context.roamingSettings.saveAsync((result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve();
          } else {
            reject(result.error);
          }
        });
      } catch (error) {
        console.error("Error setting Office storage:", error);
        reject(error);
      }
    });
  }

  async remove(key: string): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (!Office.context.roamingSettings) {
          return reject("Office storage not available");
        }

        const settings = Office.context.roamingSettings;
        const prefix = `${key}_`;

        for (const storedKey in settings) {
          if (storedKey === key || storedKey.startsWith(prefix)) {
            settings.remove(storedKey);
          }
        }

        settings.saveAsync((result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve();
          } else {
            reject(result.error);
          }
        });
      } catch (error) {
        console.error("Error removing from Office storage:", error);
        reject(error);
      }
    });
  }
}
